import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    @font-face {
        font-family: IranYekan;
        font-style: normal;
        font-weight: bold;
        src: url('/fonts/eot/iranyekanwebbold.eot');
        src: url('/fonts/eot/iranyekanwebbold.eot?#iefix') format('embedded-opentype'),
        url('/fonts/woff/iranyekanwebbold.woff') format('woff'),
        url('/fonts/ttf/iranyekanwebbold.ttf') format('truetype');
    }
    @font-face {
        font-family: IranYekan;
        font-style: normal;
        font-weight: 500;
        src: url('/fonts/eot/iranyekanwebmedium.eot');
        src: url('/fonts/eot/iranyekanwebmedium.eot?#iefix') format('embedded-opentype'),
        url('/fonts/woff/iranyekanwebmedium.woff') format('woff'),
        url('/fonts/ttf/iranyekanwebmedium.ttf') format('truetype');
    }
    @font-face {
        font-family: IranYekan;
        font-style: normal;
        font-weight: normal;
        src: url('/fonts/eot/iranyekanweblight.eot');
        src: url('/fonts/eot/iranyekanweblight.eot?#iefix') format('embedded-opentype'),
        url('/fonts/woff/iranyekanweblight.woff') format('woff'),
        url('/fonts/ttf/iranyekanweblight.ttf') format('truetype');
    }
    
    * {
        padding: 0;
        margin: 0;
        font-family: 'IranYekan', cursive;
        outline: 0;
        text-decoration: none;
        box-sizing: border-box;
    }

    body {
        background: #151515;
        direction: rtl;
        user-select: none;
    }

    a {
      color: #444;
    }
    
    button {
    	appearance: none;
    	cursor: pointer;
    }
    
    .route-section {
    	height: 100%;
    }

    #main-wrapper {
        width: 100%;
        height: 100vh;
        float: left;
    }
    
    .simpleFade-enter {
      opacity: 0;
    }
    
    .simpleFade-enter.simpleFade-enter-active {
        opacity: 1;
        transition: opacity 50ms ease;
    }
    
    .simpleFade-exit {
        opacity: 1;
    }
    
    .simpleFade-exit.simpleFade-exit-active {
        opacity: 0;
        transition: opacity 50ms ease;
    }
    
    .overlayFade-enter {
        opacity: 0;
    }
    
    .overlayFade-enter.overlayFade-enter-active {
        opacity: 1;
        transition: opacity 300ms ease;
    }
    
    .overlayFade-exit {
        opacity: 1;
    }
    
    .overlayFade-exit.overlayFade-exit-active {
        opacity: 0;
        transition: opacity 300ms ease;
    }
    
    .FadeBottom-enter {
        opacity: 0;
        transform: translateY(10px);
    }
    
    .FadeBottom-enter.FadeBottom-enter-active {
        opacity: 1;
        transform: translateY(0px);
        transition: all 300ms ease;
    }
    
    .FadeBottom-exit {
        opacity: 1;
        transform: translateY(0px);
    }
    
    .FadeBottom-exit.FadeBottom-exit-active {
        opacity: 0;
        transform: translateY(10px);
        transition: all 300ms ease;
    }
    
    .fade-enter {
	  	opacity: 0;
	}
	.fade-enter-active {
		 opacity: 1;
		 transition: opacity 200ms;
	}
	.fade-exit {
		opacity: 1;
	}
	.fade-exit-active {
		opacity: 0;
		transition: opacity 200ms;
	}
    
    .half-table {
    	width: calc(50% - 20px) !important;
    }
    
    .d-flex {
        display: flex;
		align-items: center;
		justify-content: center;
		flex: 1;
    }
    
    .align-flex-start {
    	align-items: flex-start !important;
    }
    
    .fullscreen-loading {
    	height: 100vh;
    	display: flex;
    	align-items: center;
    	justify-content: center;
    }
`;
